import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TitledPanel from '../../core/TitledPanel';
import React from 'react';
import GS from '../../grafsync/grafsync';
import { makeCancelable } from '../../core/utils/utils';
import Loading from '../../core/Loading';
import Warning from '../../core/Warning';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';

class CollectionStatistics extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isErrored: false,
            isFailed: false
        };
        this.cancellable = null;
    }

    componentDidMount() {
        this.loadData()
            .promise
            .then((collectionData) => {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({ data: collectionData.graph, isLoading: false });
            })
            .catch(() => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({
                    isErrored: true,
                    isLoading: false,
                    isFailed: true,
                    message: "Could not load all of the data for the statistics view."
                });
            });
    }

    onExitWarning = () => {
        this.setState({ isErrored: false });
    }

    loadData() {
        const name = this.props.ordered ? "collectionstatistics" : "unorderedcollectionstatistics";
        this.cancellable = makeCancelable(
            GS.export(name, this.props.id, this.props.graph)
        );
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    render() {

        const { classes } = this.props;
        const { isLoading, isErrored, message, data, isFailed } = this.state;

        if (isErrored) return <Warning message={message} onExitWarning={this.onExitWarning} />;
        if (isLoading) return <Loading minHeight="140px" offset="100px" />;
        if (isFailed) return null;

        return (
            <Grid container spacing={2} classes={
                {
                    "spacing-xs-2": this.props.classes.fullGrid
                }
            }>
                <Grid item xs={6} lg={4}>
                    <TitledPanel fontSize="large" title="Basic Statistics">
                        <Typography className={classes.subSubHeading}>Member Count</Typography>
                        <Typography data-test="member-count" className={classes.statistic}>{data.find(stat =>
                            stat.type === "https://grafsync.graphifi.com/schema/vm-skos-view/ConceptCount").viewCount}</Typography>
                    </TitledPanel>
                </Grid>
            </Grid>
        );
    }
}

CollectionStatistics.propTypes = {
    classes: PropTypes.object,
    id: PropTypes.string.isRequired,
    ordered: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(CollectionStatistics);